<div class="display-flex flex-column">
  <div mat-dialog-title class="display-flex modal-header">
    <ng-container [ngTemplateOutlet]="data?.isNew ? newTicketHeaderTemplate : editTicketHeaderTemplate"></ng-container>
  </div>

  <mat-dialog-content>
    <form [formGroup]="form" *ngIf="form">
      <div class="display-flex justify-content-space-between overflow-auto">
        <div class="display-flex flex-column grid-gap-12 details-container">
          <div class="display-flex grid-gap-16">
            <app-user-select-dropdown
              class="flex-1"
              [containerCss]="'display-flex flex-column'"
              [allowClear]="false"
              [labelRequired]="true"
              [label]="'Assignee'"
              [labelCss]="'nowrap body-small-bold'"
              [formControl]="assigneeId"
              [users]="users"
              [attrPlaceholder]="'select assignee'"
              [showValidationError]="formSubmitted"
              [attrDisable]="isTicketDone"
              attrAppendTo="body"
              [listLoading]="propertyUserListLoading$ | async"
            ></app-user-select-dropdown>
            <app-radio-button-dropdown
              [containerCss]="'w-162'"
              [autoSortList]="false"
              [items]="priorityTypeList"
              [label]="'Priority'"
              [labelCss]="'body-small-bold nowrap'"
              [containerWidthCss]="'w-123'"
              [formControl]="ticketPriorityType"
              [allowClear]="false"
              [attrPlaceholder]="'priority'"
              [labelRequired]="true"
              [attrDisable]="isTicketDone"
              attrAppendTo="body"
            ></app-radio-button-dropdown>
            <app-date-dropdown
              [formControl]="end"
              [buttonCss]="'date-dropdown-button-small w-162'"
              [containerCss]="'display-flex flex-column'"
              [label]="'Due'"
              [labelCss]="'body-small-bold nowrap'"
              [labelRequired]="true"
              [attrDisable]="isTicketDone"
              [attrPlaceholder]="'select date'"
            ></app-date-dropdown>
          </div>
          <app-input
            class="w-100"
            [labelCss]="'body-small-bold nowrap'"
            [attrLabel]="'Title'"
            [contentCss]="'display-flex flex-column fill body-small'"
            [formControl]="name"
            [attrPlaceholder]="'a mind blowing ticket title...'"
            [attrDisable]="isTicketDone || !data.isNew"
            [labelRequired]="true"
            [showValidationError]="formSubmitted"
            [displayCounter]="true"
            [maxCounter]="50"
          ></app-input>
          <app-input-area
            class="w-100"
            [label]="'Description'"
            [inputCss]="'hp-80'"
            [labelCss]="'body-small-bold nowrap'"
            [containerCss]="'fill body-small'"
            [formControl]="detailedInformation"
            [attrPlaceholder]="'a mind blowing ticket title...'"
            [attrDisable]="isTicketDone"
            [showValidationError]="formSubmitted"
            [displayCounter]="true"
            [maxCounter]="1000"
          ></app-input-area>
          <app-attachment
            [cleanInputAttachment]="cleanInputAttachment"
            (attachmentItemEvent)="addTicketAttachment($event)"
            [lockFields]="isTicketDone"
          ></app-attachment>
          <div class="display-flex flex-column grid-gap-4 attachment-list-container" #attachments>
            <app-attachments-list
              [attachments]="attachmentItems"
              [showEmpty]="!!newAttachmentItem"
              (removeAttachment)="deleteTicketAttachment($event)"
            ></app-attachments-list>
            <app-attachment-item
              [newAttachmentItem]="newAttachmentItem"
              [lockDelete]="isTicketDone"
              (deleteEvent)="deleteNewTicketAttachment()"
            ></app-attachment-item>
          </div>
        </div>
      </div>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions class="justify-content-space-between">
    <button mat-stroked-button color="warn" class="modal-button" (click)="cancel()">Cancel</button>
    <div class="display-flex grid-gap-8">
      <button
        *ngIf="!data?.isNew"
        mat-stroked-button
        color="primary"
        class="modal-button"
        (click)="markAsDone()"
        [disabled]="isTicketDone || (updateInProgress$ | async) || !ableToResolve?.value"
      >
        <div class="display-flex align-items-center grid-gap-4">
          Mark as done
          <mat-spinner *ngIf="updateInProgress$ | async" color="accent" diameter="20"></mat-spinner>
        </div>
      </button>

      <button
        mat-raised-button
        color="primary"
        class="modal-button"
        (click)="save()"
        [disabled]="isTicketDone || (updateInProgress$ | async) || (addNewInProgress$ | async) || !ableToResolve?.value"
      >
        <div class="display-flex align-items-center grid-gap-4">
          {{ data.isNew ? 'Create' : 'Save changes' }}
          <mat-spinner
            *ngIf="(updateInProgress$ | async) || (addNewInProgress$ | async)"
            color="accent"
            diameter="20"
          ></mat-spinner>
        </div>
      </button>
    </div>
  </mat-dialog-actions>
</div>

<ng-template #newTicketHeaderTemplate>
  <div class="subtitle mr-4">New ticket:</div>
  <ng-container [ngTemplateOutlet]="unitPropertyTemplate"></ng-container>
</ng-template>
<ng-template #editTicketHeaderTemplate>
  <ng-container [ngTemplateOutlet]="unitPropertyTemplate"></ng-container>
</ng-template>

<ng-template #unitPropertyTemplate>
  <div class="subtitle">{{ data?.propertyName || '' }} - {{ data?.unitName }}</div>
</ng-template>
